export const TableHeaders = [
  {
    commissions: [
      {
        id: "invoice_id",
        label: "Invoice ID",
        trsText: "invoiceId",
      },
      {
        id: "price",
        label: "Amount",
        trsText: "amount",
      },
      {
        id: "student_name",
        label: "Student Name",
        trsText: "studentName",
      },
      {
        id: "commission_amount",
        label: "Commission Amount",
        trsText: "commissionAmount",
      },
      {
        id: "commission_type",
        label: "Type",
        trsText: "type",
      },
      {
        id: "issue_date",
        label: "Issue Date",
        trsText: "issueDate",
      },
      // {
      //   id: "sm_accommodation_commission_rate",
      //   label: "Commission Rate",
      // },
      {
        id: "due_date",
        label: "Last Payment Date",
        trsText: "lastPaymentDate",
      },
      // {
      //   id: "invoice_dual_occupancy",
      //   label: "Occupancy",
      // },
      {
        id: "status",
        label: "Invoice Status",
        trsText: "invoiceStatus",
      },
      {
        id: "commission_paid_status",
        label: "Commission Status",
        trsText: "commissionStatus",
      },
      {
        id: "agent_name",
        label: "Created By",
        trsText: "createdBy",
      },
    ],
  },
  {
    bookings: [
      {
        id: "invoice_id",
        label: "Invoice ID",
        trsText: "invoiceId",
      },
      // {
      //   id: "invoice_course_id",
      //   label: "Course ID",
      // },
      {
        id: "student_name",
        label: "Student Name",
        trsText: "studentName",
      },
      {
        id: "residence_name",
        label: "Residence Name",
        trsText: "residenceName",
      },
      {
        id: "created_at",
        label: "Created At",
        trsText: "createdAt",
      },
      {
        id: "home_country",
        label: "Home Country",
        trsText: "homeCountry",
      },
      // {
      //   id: "preferred_language",
      //   label: "Preferred Language",
      // },
      {
        id: "invoice_status",
        label: "Invoice Status",
        trsText: "invoiceStatus",
      },
      {
        id: "duration",
        label: "Duration / Weekly",
        trsText: "durationWeekly",
      },
      {
        id: "check_in",
        label: "Check In",
        trsText: "checkIn",
      },
      {
        id: "check_out",
        label: "Check Out",
        trsText: "checkOut",
      },
      {
        id: "invoice_course_price",
        label: "Amount",
        trsText: "amount",
      },
      {
        id: "overdue",
        label: "Overdue",
        trsText: "overdue",
      },
      {
        id: "agent_name",
        label: "Created By",
        trsText: "createdBy",
      },
    ],
  },
  {
    invoices: [
      {
        id: "invoice_id",
        label: "Invoice Number",
        trsText: "invoiceNumber",
      },
      {
        id: "student_name",
        label: "Student Name",
        trsText: "studentName",
      },
      {
        id: "invoice_type",
        label: "Type",
        trsText: "type",
      },
      {
        id: "issue_date",
        label: "Issue Date",
        trsText: "issueDate",
      },
      {
        id: "status",
        label: "Status",
        trsText: "status",
      },
      {
        id: "amount",
        label: "Total Amount",
        trsText: "totalAmount",
      },
      {
        id: "paid",
        label: "Total Paid",
        trsText: "totalPaid",
      },
      {
        id: "outstanding",
        label: "Total Out Standing",
        trsText: "totalOutStanding",
      },
      {
        id: "agent_name",
        label: "Created By",
        trsText: "createdBy",
      },
    ],
  },
  {
    partner_requests: [
      {
        id: "student_id",
        label: "Student ID",
        trsText: "studentId",
      },
      {
        id: "student_name",
        label: "Student Name",
        trsText: "studentName",
      },
      {
        id: "student_phone",
        label: "Student Phone",
        trsText: "studentPhone",
      },
      {
        id: "student_school",
        label: "Student School",
        trsText: "studentSchool",
      },
      {
        id: "created_at",
        label: "Date Added",
        trsText: "dateAdded",
      },
      {
        id: "agent_name",
        label: "Created By",
        trsText: "createdBy",
      },
    ],
  },
  {
    quotes: [
      {
        id: "quote_id",
        label: "Quote ID",
        trsText: "quoteId",
      },
      {
        id: "student_name",
        label: "Student Name",
        trsText: "studentName",
      },
      {
        id: "quote_status",
        label: "Status",
        trsText: "status",
      },
      {
        id: "accepted_at",
        label: "Accepted At",
        trsText: "acceptedAt",
      },
      {
        id: "issue_date",
        label: "Issue Date",
        trsText: "issueDate",
      },
      {
        id: "agent_name",
        label: "Created By",
        trsText: "createdBy",
      },
    ],
  },
  {
    discount_request: [
      {
        id: "id",
        label: "ID",
        trsText: "id",
      },
      {
        id: "agency_agent",
        label: "Requested By",
        trsText: "requestedBy",
      },
      {
        id: "quote_id",
        label: "Quote ID",
        trsText: "quoteId",
      },
      {
        id: "discount_name",
        label: "Discount Name",
        trsText: "discountName",
      },
      {
        id: "amount",
        label: "Amount", // frontende tooltip ile fixed/percentage gösterilebilir
        trsText: "amount",
      },
      {
        id: "note",
        label: "Note",
        trsText: "note",
      },
      {
        id: "created_at",
        label: "Created At",
        trsText: "createdAt",
      },
      {
        id: "updated_at",
        label: "Updated At",
        trsText: "updatedAt",
      },
      {
        id: "status",
        label: "Status",
        trsText: "status",
      },
      {
        id: "actions",
        label: "Actions",
        trsText: "actions",
      },
    ],
  },
]

export const TableHeadersSm = [
  {
    commissions: [
      {
        id: "invoice_id",
        label: "Invoice ID",
        trsText: "invoiceId",
      },
      {
        id: "status",
        label: "Status",
        trsText: "status",
      },
    ],
  },
  {
    partner_requests: [
      {
        id: "student_id",
        label: "Student ID",
        trsText: "studentId",
      },
      {
        id: "student_name",
        label: "Student Name",
        trsText: "studentName",
      },
    ],
  },
  {
    bookings: [
      {
        id: "invoice_id",
        label: "Invoice ID",
        trsText: "invoiceId",
      },
      {
        id: "student_name",
        label: "Student Name",
        trsText: "studentName",
      },
    ],
  },
  {
    invoices: [
      {
        id: "invoice_id",
        label: "Invoice Number",
        trsText: "invoiceNumber",
      },
      {
        id: "status",
        label: "Status",
        trsText: "status",
      },
    ],
  },
  {
    quotes: [
      {
        id: "quote_id",
        label: "Quote ID",
        trsText: "quoteId",
      },
      {
        id: "quote_status",
        label: "Status",
        trsText: "status",
      },
    ],
  },
  {
    discount_request: [
      {
        id: "id",
        label: "ID",
        trsText: "id",
      },
      {
        id: "actions",
        label: "Actions",
        trsText: "actions",
      },
    ],
  },
]

export const TableHeadersMd = [
  {
    commissions: [
      {
        id: "invoice_id",
        label: "Invoice ID",
        trsText: "invoiceId",
      },
      {
        id: "status",
        label: "Status",
        trsText: "status",
      },
    ],
  },
  {
    bookings: [
      {
        id: "invoice_id",
        label: "Invoice ID",
        trsText: "invoiceId",
      },
      {
        id: "student_name",
        label: "Student Name",
        trsText: "studentName",
      },
      {
        id: "check_in",
        label: "Check In",
        trsText: "checkIn",
      },
      {
        id: "check_out",
        label: "Check Out",
        trsText: "checkOut",
      },
      {
        id: "invoice_course_price",
        label: "Amount",
        trsText: "amount",
      },
    ],
  },
  {
    partner_requests: [
      {
        id: "student_id",
        label: "Student ID",
        trsText: "studentId",
      },
      {
        id: "student_name",
        label: "Student Name",
        trsText: "studentName",
      },
      {
        id: "student_phone",
        label: "Student Name",
        trsText: "studentName",
      },
    ],
  },
  {
    invoices: [
      {
        id: "invoice_id",
        label: "Invoice Number",
        trsText: "invoiceNumber",
      },
      {
        id: "amount",
        label: "Total Amount",
        trsText: "totalAmount",
      },
      {
        id: "status",
        label: "Status",
        trsText: "status",
      },
    ],
  },
  {
    quotes: [
      {
        id: "quote_id",
        label: "Quote ID",
        trsText: "quoteId",
      },
      {
        id: "student_name",
        label: "Student Name",
        trsText: "studentName",
      },
      {
        id: "quote_status",
        label: "Status",
        trsText: "status",
      },
    ],
  },
  {
    discount_request: [
      {
        id: "id",
        label: "ID",
        trsText: "id",
      },
      {
        id: "agency_agent",
        label: "Requested By",
        trsText: "requestedBy",
      },
      {
        id: "actions",
        label: "Actions",
        trsText: "actions",
      },
    ],
  },
]



/* export const TableHeaders = [
  {
    commissions: [
      {
        id: "invoice_id",
        label: "Invoice ID",
      },
      {
        id: "price",
        label: "Amount",
      },
      {
        id: "student_name",
        label: "Student Name",
      },
      {
        id: "commission_amount",
        label: "Commission Amount",
      },
      {
        id: "commission_type",
        label: "Type",
      },
      {
        id: "issue_date",
        label: "Issue Date",
      },
      // {
      //   id: "sm_accommodation_commission_rate",
      //   label: "Commission Rate",
      // },
      {
        id: "due_date",
        label: "Last Payment Date",
      },
      // {
      //   id: "invoice_dual_occupancy",
      //   label: "Occupancy",
      // },
      {
        id: "status",
        label: "Invoice Status",
      },
      {
        id: "commission_paid_status",
        label: "Commission Status",
      },
      {
        id: "agent_name",
        label: "Created By",
      },
    ],
  },
  {
    bookings: [
      {
        id: "invoice_id",
        label: "Invoice ID",
      },
      // {
      //   id: "invoice_course_id",
      //   label: "Course ID",
      // },
      {
        id: "student_name",
        label: "Student Name",
      },
      {
        id: "residence_name",
        label: "Residence Name",
      },
      {
        id: "created_at",
        label: "Created At",
      },
      {
        id: "home_country",
        label: "Home Country",
      },
      // {
      //   id: "preferred_language",
      //   label: "Preferred Language",
      // },
      {
        id: "invoice_status",
        label: "Invoice Status",
      },

      {
        id: "duration",
        label: "Duration / Weekly",
      },
      {
        id: "check_in",
        label: "Check In",
      },
      {
        id: "check_out",
        label: "Check Out",
      },
      {
        id: "invoice_course_price",
        label: "Amount",
      },
      {
        id: "overdue",
        label: "Overdue",
      },
      {
        id: "agent_name",
        label: "Created By",
      },
    ],
  },
  {
    invoices: [
      {
        id: "invoice_id",
        label: "Invoice Number",
      },
      {
        id: "student_name",
        label: "Student Name",
      },
      {
        id: "invoice_type",
        label: "Type",
      },
      {
        id: "issue_date",
        label: "Issue Date",
      },
      {
        id: "status",
        label: "Status",
      },
      {
        id: "amount",
        label: "Total Amount",
      },
      {
        id: "paid",
        label: "Total Paid",
      },
      {
        id: "outstanding",
        label: "Total Out Standing",
      },
      {
        id: "agent_name",
        label: "Created By",
      },
    ],
  },
  {
    partner_requests: [
      {
        id: "student_id",
        label: "Student ID",
      },
      {
        id: "student_name",
        label: "Student Name",
      },
      {
        id: "student_phone",
        label: "Student Phone",
      },
      {
        id: "student_school",
        label: "Student School",
      },
      {
        id: "created_at",
        label: "Date Added",
      },
      {
        id: "agent_name",
        label: "Created By",
      },
    ],
  },
  {
    quotes: [
      {
        id: "quote_id",
        label: "Quote ID",
      },
      {
        id: "student_name",
        label: "Student Name",
      },
      {
        id: "quote_status",
        label: "Status",
      },
      {
        id: "accepted_at",
        label: "Accepted At",
      },
      {
        id: "issue_date",
        label: "Issue Date",
      },
      {
        id: "agent_name",
        label: "Created By",
      },
    ],
  },
  {
    discount_request: [
      {
        id: "id",
        label: "ID",
      },
      {
        id: "agency_agent",
        label: "Requested By",
      },
      {
        id: "quote_id",
        label: "Quote ID",
      },
      {
        id: "discount_name",
        label: "Discount Name",
      },
      {
        id: "amount",
        label: "Amount", // frontende tooltip ile fixed/percentage gösterilebilir
      },
      {
        id: "note",
        label: "Note",
      },
      {
        id: "created_at",
        label: "Created At",
      },
      {
        id: "updated_at",
        label: "Updated At",
      },
      {
        id: "status",
        label: "Status",
      },
      {
        id: "actions",
        label: "Actions",
      },
    ],
  },
];

export const TableHeadersSm = [
  {
    commissions: [
      {
        id: "invoice_id",
        label: "Invoice ID",
      },
      {
        id: "status",
        label: "Status",
      },
    ],
  },
  {
    partner_requests: [
      {
        id: "student_id",
        label: "Student ID",
      },
      {
        id: "student_name",
        label: "Student Name",
      },
    ],
  },
  {
    bookings: [
      {
        id: "invoice_id",
        label: "Invoice ID",
      },
      {
        id: "student_name",
        label: "Student Name",
      },
    ],
  },
  {
    invoices: [
      {
        id: "invoice_id",
        label: "Invoice Number",
      },
      {
        id: "status",
        label: "Status",
      },
    ],
  },
  {
    quotes: [
      {
        id: "quote_id",
        label: "Quote ID",
      },

      {
        id: "quote_status",
        label: "Status",
      },
    ],
  },
  {
    discount_request: [
      {
        id: "id",
        label: "ID",
      },
      {
        id: "actions",
        label: "Actions",
      },
    ],
  },
];

export const TableHeadersMd = [
  {
    commissions: [
      {
        id: "invoice_id",
        label: "Invoice ID",
      },
      {
        id: "status",
        label: "Status",
      },
    ],
  },
  {
    bookings: [
      {
        id: "invoice_id",
        label: "Invoice ID",
      },
      {
        id: "student_name",
        label: "Student Name",
      },
      {
        id: "check_in",
        label: "Check In",
      },
      {
        id: "check_out",
        label: "Check Out",
      },
      {
        id: "invoice_course_price",
        label: "Amount",
      },
    ],
  },
  {
    partner_requests: [
      {
        id: "student_id",
        label: "Student ID",
      },
      {
        id: "student_name",
        label: "Student Name",
      },
      {
        id: "student_phone",
        label: "Student Name",
      },
    ],
  },
  {
    invoices: [
      {
        id: "invoice_id",
        label: "Invoice Number",
      },

      {
        id: "amount",
        label: "Total Amount",
      },
      {
        id: "status",
        label: "Status",
      },
    ],
  },
  {
    quotes: [
      {
        id: "quote_id",
        label: "Quote ID",
      },
      {
        id: "student_name",
        label: "Student Name",
      },
      {
        id: "quote_status",
        label: "Status",
      },
    ],
  },

  {
    discount_request: [
      {
        id: "id",
        label: "ID",
      },
      {
        id: "agency_agent",
        label: "Requested By",
      },
      {
        id: "actions",
        label: "Actions",
      },
    ],
  },
];
 */